export default __webpack_public_path__ + "static/media/p-3.45bad73d.png";